import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAdmin } from '../../context/AdminContext';
import { adminListMachines, adminDeleteMachine } from '../../services/toolsApi';

const AdminMachines = () => {
  const { password } = useAdmin();
  const [machines, setMachines] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const data = await adminListMachines(password);
      setMachines(data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleDelete = async (id) => {
    if (!window.confirm(`Delete machine "${id}" and all its tools?`)) return;
    try {
      await adminDeleteMachine(password, id);
      load();
    } catch (err) {
      alert(err.message);
    }
  };

  if (loading) {
    return <div className="flex justify-center py-12"><div className="w-8 h-8 border-3 border-dewalt border-t-transparent rounded-full animate-spin" /></div>;
  }

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-xl font-bold text-black">Vending Machines</h1>
        <Link
          to="/admin/machines/new"
          className="px-4 py-2 bg-dewalt text-black text-sm font-bold rounded-lg no-underline hover:bg-dewalt-hover"
        >
          + New Machine
        </Link>
      </div>

      {machines.length === 0 ? (
        <p className="text-gray-500 text-center py-8">No machines yet</p>
      ) : (
        <div className="space-y-3">
          {machines.map((m) => (
            <div key={m.id} className="bg-white rounded-xl border border-gray-200 p-4 flex items-center justify-between">
              <div>
                <div className="font-semibold text-black">{m.name.uk}</div>
                <div className="text-sm text-gray-500">{m.id} &middot; {m.location.uk}</div>
                <span className={`inline-block mt-1 text-xs px-2 py-0.5 rounded ${m.isActive ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-500'}`}>
                  {m.isActive ? 'Active' : 'Inactive'}
                </span>
              </div>
              <div className="flex items-center gap-2">
                <Link
                  to={`/admin/machines/${m.id}/tools`}
                  className="px-3 py-1.5 text-sm bg-gray-100 text-gray-700 rounded-lg no-underline hover:bg-gray-200"
                >
                  Tools
                </Link>
                <Link
                  to={`/admin/machines/${m.id}/edit`}
                  className="px-3 py-1.5 text-sm bg-gray-100 text-gray-700 rounded-lg no-underline hover:bg-gray-200"
                >
                  Edit
                </Link>
                <button
                  onClick={() => handleDelete(m.id)}
                  className="px-3 py-1.5 text-sm bg-red-50 text-red-600 rounded-lg border-none cursor-pointer hover:bg-red-100"
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminMachines;
